// extracted by mini-css-extract-plugin
export default {"token":"KycDetailsCard_token__IMmnC","leftLoader":"KycDetailsCard_leftLoader__aSs16"};